function labelOf(el) {
  return (el.getAttribute('data-track-label') || el.textContent || '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 80);
}

// One delegated listener classifies clicks site-wide:
//  - anything with data-track="<location>"  -> cta_click
//  - mailto: links                          -> email_click
//  - tel: links                             -> phone_click
//  - .pdf links                             -> file_download
//  - links to another site                  -> outbound_click
export function classifyClick(target, here) {
  const el = target && target.closest ? target.closest('a, button') : null;
  if (!el) return null;

  const href = el.tagName === 'A' ? el.getAttribute('href') || '' : '';
  let url = null;
  try {
    url = href ? new URL(href, here.href) : null;
  } catch {
    url = null;
  }
  const external = url && /^https?:$/.test(url.protocol) && url.host !== here.host;

  if (el.hasAttribute('data-track')) {
    const props = { label: labelOf(el), location: el.getAttribute('data-track') };
    if (external) props.url = url.origin + url.pathname;
    return ['cta_click', props];
  }
  if (!url) return null;
  if (url.protocol === 'mailto:') return ['email_click', { label: labelOf(el) }];
  if (url.protocol === 'tel:') return ['phone_click', { label: labelOf(el) }];
  if (/\.pdf$/i.test(url.pathname)) return ['file_download', { file: url.pathname }];
  if (external) return ['outbound_click', { url: url.origin + url.pathname, label: labelOf(el) }];
  return null;
}
